import React from "react";
import closeImg from "../../Assets/images/close.svg";
import back from "../../Assets/images/back.svg"

import { isMobile } from "../../utils/utils.js";

const PopUpBack = (
   {
      cssClass,
      children,
      heading,
      showStatus,
      showOnDesktop,
      details,
      addAutoUnderWritingCss,
      showExceptionStatus,
      popUpBottom,
      removeHeader,
      popupHead,onClose,
    } 
) => {
  const closeHandler = () => {
    onClose();
  };

    const backHandler = () => {
    backHandler();
  };
  
  return (
     <div role="mobilePopup_testRole" data-testid="mobilePopup_testId"
        className={`mainPopUpWrap ${popUpBottom ? "popUpBottomCss" : ""} ${cssClass} ${
          !isMobile() && showOnDesktop ? "showOnDesktop" : ""
        }`}
      >
        <span className={`backgroundOverlay`} onClick={closeHandler} />
        <div className="mobilePopUpWrap ">
          {removeHeader ? null : <div className="pop-top-sec">
            {popupHead ? <div  data-testid="mobilePopup_cancelBtn" className="popup-header">{popupHead}</div>: ''}
            <span className="close-btn" onClick={closeHandler}>
              <img alt="Close" src={closeImg} />
            </span>
            {
              heading && 
              <div className="heading">{heading}</div>
            }
          </div>}

          <div className="pop-btm-sec">{children}</div>
        </div>
      </div>
  );
};

export default PopUpBack;
